import React, { useCallback, useEffect } from 'react';
import { KoFormBuilder, KoForm, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './curd.module.scss';

function KoFolderCrud({ form, handleFinish, initialValues, currentFolder }) {

  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form.resetFields();
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);


  const handleSubmit = useCallback(values => {
    handleFinish(values);
  });


  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      { key: 'name', placeholder: 'Enter folder name', label: 'Name', colSpan: 4, rules: [
        {
          required: true,
          message: `Enter new folder name.`
        }
      ] }
     
    ]
  };

  return (
    <div className={styles.wrapper}>
      {currentFolder&&  <div className={styles.parentFolder}>
        <KoIcon name={'FolderLine'} />
        <KoTitle level={5} text={`${currentFolder?.name?.toUpperCase() || 'My Drive'}`} />
        <KoIcon name={'ArrowRightOutlined'} />
      </div>}
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
};

export default KoFolderCrud;